import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { createSupplierAcknowledgementMutations } from "@/app/Suppliers/GraphQL/supplierAcknowledgementMutations";
import { CreateSupplierAcknowledgementInput } from "@/gql/graphql";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { SupplierAcknowledgementForm } from "@/app/Suppliers/Forms/SupplierAcknowledgementForm";

export function SupplierAcknowledgementCreateDialog({
  supplierId,
}: {
  supplierId: string;
}) {
  const { close } = useDialogState();
  const { mutateAsync } = useGqlMutation(
    createSupplierAcknowledgementMutations,
  );

  return (
    <BaseDialog title="Add Acknowledgement">
      <GenericForm<CreateSupplierAcknowledgementInput>
        initialValues={{
          supplier_id: supplierId,
          name: "",
          acknowledgement: "",
        }}
        onSubmit={async (values) => {
          await mutateAsync({
            input: values,
          });
          await close();
        }}
      >
        <SupplierAcknowledgementForm />
        <DialogSubmitButton text="Add Acknowledgement" />
      </GenericForm>
    </BaseDialog>
  );
}
